var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.875 12.375L31.6875 18.5625L35.0625 35.25C35.25 35.8125 35.0625 36.5625 34.5 36.9375L33.1875 38.25C32.25 39.1875 30.5625 38.8125 30.1875 37.6875L25.3125 25.125L18.9375 31.5L19.3125 35.625C19.3125 36.1875 19.125 36.75 18.75 37.125L16.6875 39.1875L12.75 32.625L6.1875 28.6875L8.0625 26.25C8.4375 25.875 9 25.6875 9.5625 25.6875L13.6875 26.0625L20.0625 19.6875L7.3125 14.8125C6.1875 14.25 5.8125 12.75 6.75 11.8125L8.0625 10.5C8.4375 10.125 9.1875 9.9375 9.75 9.9375L26.4375 13.3125L32.625 7.125C34.125 5.625 36.375 5.625 37.875 7.125C39.375 8.625 39.375 10.875 37.875 12.375Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAirplane);
export default __webpack_public_path__ + "static/media/navigation-airplane.e37b5fea.svg";
export { ForwardRef as ReactComponent };